export const api = {
    clientId: '4ec7f5e663038347d5bd80ac6b1b174d',
};
